import { getLocalStorageItem } from './utils/localStorageUtil';
import { MEDICAL_PROVIDER_TYPE, MEDICAL_RECORD_TYPE } from '@demandproai/shared';

const baseCaseUrl = '/api/case';

class Constants {
    static isDiscoveryHidden = true;

    static ApiUrl = {
        createRequest: '/createRequest',
        generateuintArray: '/generateuintArray',
        pdfConverter: "/upload-pdf",
        getErrorLog: '/GetErrorLog',
        suggestedEditRequestStatuses: '/suggested-edit-request-statuses',
        suggestedEditPreviousSection: '/suggested-edit-history/previous-section',
        suggestedEditAvailableSections: '/suggested-edit-history/available-sections',
        suggestedEditOriginalValues: '/suggested-edit-history/original-values',
        regenerateDemandLetters: '/regenerate-demand-letters',
        regenerateLifecarePlan: '/regenerate-lifecare-plan',
        preSignedUrls: '/dedicated-presigned-url',
        addDedicatedFile: '/dedicated-file-upload',
        downloadCaseFilesZip: '/api/download/caseFilesZip',
        pfqDownload: {
            generate: '/api/download/generatePdf',
            invoice: '/api/download/downloadCaseInvoicePdf',
            singleFile: '/api/download/downlodSingleFile',
        },
        docxPreview: '/api/downloadFile/docxPreview',

        curriculumVitae: {
            get: '/api/curriculum-vitae/get_curriculum_vitae',
            remove: '/api/curriculum-vitae/remove_curriculum_vitae',
        },

        records: {
            remove: '/api/record-file/remove_record',
            get: '/api/record-file/get_records',
        },

        signature: {
            get: '/api/signature',
            put: '/api/signature',
            delete: '/api/signature',
        },

        version: {
            history: '/api/version/history',
            download: '/api/version/download',
            caseFilesHistory: '/api/version/case-files/history',
            caseFilesDownload: '/api/version/case-files/download',
            lifecarePlanDownload: '/api/version/lifecare-plan/download',
            certifiedLifecarePlanDownload: '/api/version/certified-lifecare-plan/download'
        },
        removeFileRecords: '/api/remove-file-records',
        template: {
            getDemandTemplate: '/api/template/getDemandTemplate',
            deleteDemandTemplate: '/api/template/deleteDemandTemplate',
            addUpdateDemandTemplate: '/api/template/addUpdateDemandTemplate',
            getTemplateSettings: '/api/template/getTemplateSettings',
            addUpdateTemplateSettings: '/api/template/addUpdateTemplateSettings',
            getTemplates: '/api/template/getAllDemandTemplates',
            addUpdateDemandMapText: '/api/template/addUpdateDemandMapText',
            getDemandMap: '/api/setting/getDemandMap'
        },
        user: {
            add: '/api/user/add',
            getUsers: "/api/user/get-users",
            assignableUsers: "/api/user/assignable",
            getUserById: "/api/user/get-user",
            updateProfile: "/api/user/profile",
            updateUser: "/api/user/UpdateUser",
            generateApiKey: "/api/user/generateApiKey",
            storeApiKey: "/api/user/storeApiKeyIntoDb",
            revokedApiKey: "/api/user/revokedApiKey",
            getUserApiKeys: "/api/user/getUserApiKeys",
            addPartnerApiKey: "/api/user/addPartnerApiKey",
            revokePartnerApiKey: "/api/user/revokePartnerApiKey",
            getPartnerApiKeys: "/api/user/getPartnerApiKeys",
            superAdminUser: '/api/user/getSuperAdminUser',
            uploadHeadshot: '/api/user/upload-headshot',
            headshotData: '/api/user/headshot-data',
            getNotifications: '/api/user/notifications',
            updateTourState: '/api/user/onboarding/tour',
        },

        team: {
            add: '/api/team/AddEditTeam',
            getTeams: "/api/team/get-teams",
            deleteTeam: "/api/team/deleteTeam",
        },

        case: {
            baseCaseUrl,
            addCase: `${baseCaseUrl}/add-case`,
            getCases: `${baseCaseUrl}/getCases`,
            getCaseById: `${baseCaseUrl}/getCaseById`,
            getCaseRecords: (caseId) => `${baseCaseUrl}/${caseId}/records`,
            getCreateRequests: (caseId) => `/api/create-request/${caseId}`,
            getCaseResultsHistory: `${baseCaseUrl}/getCaseResultsHistory`,
            deleteCase: `${baseCaseUrl}/DeleteCase`,
            updateCaseSettledDetails: `${baseCaseUrl}/update-case-settlement`,
            updatePolicyLimitSettledStatus: `${baseCaseUrl}/updatePolicySettledStatus`,
            editComments: `${baseCaseUrl}/edit-comments`,
            getCaseFileVersions: `${baseCaseUrl}/get-case-file-versions`,
        },
        discovery: {
            getDiscoveryCases: 'api/discovery/discoveryCasesList',
            getDiscoveryImportList: 'api/discovery/discoveryImportList',
            discoveryImport: '/api/discovery/import',
            getDiscoveryOverview: 'api/discovery/overview',
            getDiscoveryObjectionGroup: 'api/discovery-objection-bank/objection-group',
            addEditPreliminaryStatement: 'api/discovery/addEditPreliminaryStatement',
            generateDiscoveryDoc: '/api/discovery/generate-discovery-doc',
            getCaseLevelDiscoverySetting: '/api/discovery-setting/getCaseLevelDiscoverySetting',
            addEditDiscoverySetting: '/api/discovery-setting/addEditDiscoverySetting',
            addEditDiscoveryObjection:'api/discovery-objection-bank/addEditDiscoveryObjection',
            deleteDiscoveryObjection:'api/discovery-objection-bank/deleteDiscoveryObjection',
            getDiscoveryExhibits: 'api/discovery/get-discovery-exhibits'
        },
        discoveryQuestion: {
            list: 'api/discovery-question/list',
            updateDiscoveryResponse: 'api/discovery-question/updateDiscoveryResponse',
            create: 'api/discovery-question/create',
            delete: 'api/discovery-question/delete'
        },
        discoveryPreference: {
            getPreferenceId: 'api/discovery-preference/getPreferenceId'
        },
        discoverySet: {
            addNewDiscoverySet: '/api/discovery-set/addNewDiscoverySet',
            uploadFile: '/api/discovery-set/upload-file',
            deleteField: '/api/discovery-set/delete-field',
            toggleLock: '/api/discovery-set/toggle-lock',
            updatePreliminaryStatement: '/api/discovery-set/preliminary-statement',
            downloadDiscoverySetQuestionFiles: '/api/download/downloadDiscoverySetQuestionFiles',
        },
        definition:{
            manage:'/api/definition/manage'
        },
        silentWitness: {
            generate: '/api/silent-witness/generate',
            deleteReport: '/api/case/delete-silent-witness-report'
        },
        companies: {
            getCompanies: '/api/companies/getcompanies',
            addCompanies: '/api/companies/addcompanies',
            updatecompanies: '/api/companies/updatecompanies',
            deleteCompanyUsers: '/api/companies/delete-company-users',
            getCompaniesOptions: '/api/companies/getCompaniesOptions',
        },
        logout: {
            logout: "/api/logout/logout",
        },
        help: {
            request: "/api/help/request",
        },
        auth: {
            superAdminSignin: '/api/auth/Supersignin',
            sigin: '/api/auth/signin',
            forgotPassword: '/api/auth/forgotPaasword',
            resetPassword: '/api/auth/resetpassword',
        },
        subscription: {
            subs: "/api/subscription/AddSubs",
        },
        company: {
            dashboard: {
                userAnalytics: '/api/company/dashboard/users-analytics',
                monthlyAnalytics: '/api/company/dashboard/company-monthly-cases-analytics',
            }
        },
        super: {
            dashboard: {
                successfulAnalytics: '/api/super/dashboard/successful-analytics',
                limboCases: '/api/super/dashboard/limbo-analytics',
                failedAnalytics: '/api/super/dashboard/failed-analytics',
                previouslyFailed: '/api/super/dashboard/previously-failed',
                runningCases: '/api/super/dashboard/running-cases',
                runningCasesUnfulfilled: '/api/super/dashboard/running-cases-unfulfilled',
                p99Time: '/api/super/dashboard/p99-time',
                demandEligibility: '/api/super/dashboard/companies-demand-eligibility',
                totalCreditCharged: '/api/super/dashboard/credit-charged-analytics',
                chatSessionsCount: '/api/super/dashboard/chat-sessions-analytics',
                companyAiCost: '/api/super/dashboard/company-ai-cost',
                companyStatus: '/api/super/dashboard/company-status',
                getSubscriptionAnalytics: '/api/super/dashboard/subscription-analytics',
                promptId :'/api/super/dashboard/prompt-ids',
                upcomingCompany:'/api/super/dashboard/upcoming-company',
                caseCountGraph: '/api/super/dashboard/case-count-graph',
                signupCountGraph: '/api/super/dashboard/signup-count-graph',
                badRecords: '/api/super/dashboard/bad-records-failed',
                pageDistribution: '/api/super/dashboard/page-distribution',
                caseContentDistribution: '/api/super/dashboard/case-content-distribution',
                badRecordsDetail: '/api/super/dashboard/bad-records-failed-detailed',
                downloadCsv: '/api/super/dashboard/download-csv',
                monthlyRecurringRevenue:'/api/super/dashboard/monthly-recurring-revenue',
                commissionPayout: '/api/super/dashboard/commission-payout',
                annualTargetTotal: '/api/super/dashboard/annual-target-total',
            },
            reports : {
                exceedingCredits: '/api/reports/exceeding-credit-companies',
                subscriptionHealth: '/api/reports/subscription-health',
                demandUsage: '/api/reports/customer-demand-usage',
            }
        },

        discoveryTemplate: {
            getDiscoveryTemplate: '/api/discovery-template/discoveryTemplate',
            addUpdateDiscoveryTemplate: '/api/discovery-template/addUpdateDiscoveryTemplate',
            deleteDiscoveryTemplate: '/api/discovery-template/deleteDiscoveryTemplate'
        },

        utils: {
            getSignedUrl: 'api/utils/getSignedUrl'
        },
        address: {
            zipCode: 'api/address/zip-code',
            suggestions: 'api/address/suggestions',
        },
        note: {
            addNote: 'api/note/add-note',
            deleteNote: 'api/note/delete-note'
        },
        caseSummary: {
            getCaseSummary: 'api/case-summary',
            getLifecarePlanValue: 'api/case-summary',
            addSettlementAmount: 'api/case-summary/settled-amount',
        },
        certifiedLifecarePlan: {
            finalize: 'api/certified-lifecare-plan/finalize',
            finalizeSnapshot: 'api/certified-lifecare-plan/finalize-snapshot',
            approve: 'api/certified-lifecare-plan/approve',
            reassign: 'api/certified-lifecare-plan/reassign',
            download: '/api/certified-lifecare-plan/download',
            getDefaultPlanner: '/api/certified-lifecare-plan/get-default-planner',
            requestSupport: '/api/certified-lifecare-plan/request-support',
        },
        costProjection: {
            record: '/api/cost-projection/record',
            status: '/api/cost-projection/status',
        },
        partner: {
            getCases: '/api/partner/cases',
            getCaseById: '/api/partner/case',
            casepeerCallbackVeify: '/api/partner/casepeer/verify-callback',
            dropboxDownload: 'api/partner/dropbox/download',
        },
        chat: {
            getMessages: '/getChat',
            handleChat: '/chat'
        },
        court: {
            getCourts: '/api/court/courts',
            createEditCourt: '/api/court/createUpdate',
        },
        design: {
            tree: '/api/design/tree',
            fileUrl: '/api/design/file-url',
        },
    }

    static RefernceVariables = [
        { value: "[Clientname]", text: "Clientname" },
        { value: "[clientFullName]", text: "Client Full Name" },
        { value: "[Faultername]", text: "Faultername" },
        { value: "[Gender]", text: "Gender" },
        { value: "[Age]", text: "Age" },
        { value: "[PastMonthlyPainAmount]", text: "PastMonthlyPainAmount" },
        { value: "[FutureYearlyPainAmount]", text: "FutureYearlyPainAmount" },
        { value: "[Amount]", text: "Amount" },
        { value: "[CreatedDate]", text: "CreatedDate" },
        { value: "[ClientProfession]", text: "ClientProfession" },
        { value: "[MissedWorkHours]", text: "MissedWorkHours" },
        { value: "[HourlyWorkingRate]", text: "HourlyWorkingRate" },
        { value: "[AccidentDate]", text: "Accident Date" },
        { value: "[PoliceReportExhibit]", text: "Police Report Exhibit" },
        { value: "[PriorMedicalRecordExhibit]", text: "Prior Medical Record Exhibit" },
        { value: "[AccidentInjuryPhotosExhibit]", text: "Accident Injury Photo Exhibit" },
        { value: "[PropertyInjuryPhotosExhibit]", text: "Property Injury Photos Exhibit" },
        { value: "[MedicalRecordExhibit]", text: "Medical Record Exhibit" },
        { value: "[MedicalBillExhibit]", text: "Medical Bill Exhibit" },
        { value: "[lifeExpectancyAge]", text: "Life Expectancy" },
        { value: "[monthsDifference]", text: "Months Difference" },
        { value: "[pastNonEconomicDamages]", text: "Past Non Economic Damages" },
        { value: "[perDayAmountForFutureNonEconomicDamages]", text: "Per Day Amount For Future Non-Economic Damages" },
        { value: "[postNonEconomicsDamagesFinalAmount]", text: "Post Non-Economics Damages Final Amount" },
        { value: "[perDayPasNonEconomicDamagesAmount]", text: "Per Day Past Non-Economic Damages Amount" },
        { value: "[perDayPasNonEconomicDamagesFinalAmount]", text: "Per Day Past Non-Economic Damages Final Amount" },
        { value: "[he/she]", text: "He/She" },
        { value: "[his/her]", text: "His/Her" },
        { value: "[him/her]", text: "Him/Her" },
        { value: "[lossofIncomeCalculatedAmount]", text: "Loss of Income Calculated Amount" },
        { value: "[PainAndSuffringSection]", text: "PainandSuffringSection" },
        { value: "</t>", text: "Tab" },
        { value: "[LLMLiabilityDescription].", text: "LLM Liability Description" },

        { value: "[LLMFactsOfIncident]", text: "LLM Facts Of Incident" },
        { value: "[LLMDangerousCondition]", text: "LLM Dangerous Conditions" },
        { value: "[LLMACNotice]", text: "LLM AC Notice" },
        { value: "[LLMAdequateWarning]", text: "LLM Adequate Warning" },
        { value: "[LLMConsumerExpectation]", text: "LLM Consumer Expectation" },
        { value: "[LLMRiskBenefit]", text: "LLM Risk Benefit" },
        { value: "[LLMManufacturingDefect]", text: "LLM Manufacturing Defect" },
        { value: "[defAdjusterName]", text: "Defendant Adjuster Name" },
        { value: "[defInsuranceName]", text: "Defendant Insurance Name" },
        { value: "[defAdjusterAddress]", text: "Defendant Adjuster Address" },
        { value: "[defAdjusterCity]", text: "Defendant Adjuster City" },
        { value: "[defAdjusterState]", text: "Defendant Adjuster State" },
        { value: "[defAdjusterZip]", text: "Defendant Adjuster Zip" },
        { value: "[clientAdjusterName]", text: "Client Adjuster Name" },
        { value: "[clientInsuranceName]", text: "Client Insurance Name" },
        { value: "[clientAdjusterAddress]", text: "Client Adjuster Address" },
        { value: "[clientAdjusterCity]", text: "Client Adjuster City" },
        { value: "[clientAdjusterState]", text: "Client Adjuster State" },
        { value: "[clientAdjusetrZip]", text: "Client Adjusetr Zip" },
        { value: "[defClaimNumber]", text: "Defendant Claim Number" },
        { value: "[clientClaimNumber]", text: "Client Claim Number" },
        { value: "[defInsuranceLastName]", text: "Defendant Insurance Last Name" },
        { value: "[LLMLossIncome]", text: "LLM Loss of Income" },
        { value: "[LLMMedicalExpenses]", text: "LLM Future Medical Expenses" }
    ]

    static Dropdowns = {
        FileType: Object.values(MEDICAL_RECORD_TYPE).map((type) => ({ value: type, text: type })),

        Tier: [
            { value: "Platinium", text: "Platinium" },
            { value: "Gold", text: "Gold" },
            { value: "Silver", text: "Silver" },
            { value: "Diamond", text: "Diamond" }
        ],

        States: [
            { value: "California", text: "California" },
            { value: "Alabama", text: "Alabama" },
            { value: "Alaska", text: "Alaska" },
            { value: "Arizona", text: "Arizona" },
            { value: "Arkansas", text: "Arkansas" },
            { value: "Colorado", text: "Colorado" },
            { value: "Connecticut", text: "Connecticut" },
            { value: "Delaware", text: "Delaware" },
            { value: "District of Columbia", text: "District of Columbia" },
            { value: "Florida", text: "Florida" },
            { value: "Georgia", text: "Georgia" },
            { value: "Hawaii", text: "Hawaii" },
            { value: "Idaho", text: "Idaho" },
            { value: "Illinois", text: "Illinois" },
            { value: "Indiana", text: "Indiana" },
            { value: "Iowa", text: "Iowa" },
            { value: "Kansas", text: "Kansas" },
            { value: "Kentucky", text: "Kentucky" },
            { value: "Louisiana", text: "Louisiana" },
            { value: "Maine", text: "Maine" },
            { value: "Maryland", text: "Maryland" },
            { value: "Massachusetts", text: "Massachusetts" },
            { value: "Michigan", text: "Michigan" },
            { value: "Minnesota", text: "Minnesota" },
            { value: "Mississippi", text: "Mississippi" },
            { value: "Missouri", text: "Missouri" },
            { value: "Montana", text: "Montana" },
            { value: "Nebraska", text: "Nebraska" },
            { value: "Nevada", text: "Nevada" },
            { value: "New Hampshire", text: "New Hampshire" },
            { value: "New Jersey", text: "New Jersey" },
            { value: "New Mexico", text: "New Mexico" },
            { value: "New York", text: "New York" },
            { value: "North Carolina", text: "North Carolina" },
            { value: "North Dakota", text: "North Dakota" },
            { value: "Ohio", text: "Ohio" },
            { value: "Oklahoma", text: "Oklahoma" },
            { value: "Oregon", text: "Oregon" },
            { value: "Pennsylvania", text: "Pennsylvania" },
            { value: "Rhode Island", text: "Rhode Island" },
            { value: "South Carolina", text: "South Carolina" },
            { value: "South Dakota", text: "South Dakota" },
            { value: "Tennessee", text: "Tennessee" },
            { value: "Texas", text: "Texas" },
            { value: "Utah", text: "Utah" },
            { value: "Vermont", text: "Vermont" },
            { value: "Virginia", text: "Virginia" },
            { value: "Washington", text: "Washington" },
            { value: "West Virginia", text: "West Virginia" },
            { value: "Wisconsin", text: "Wisconsin" },
            { value: "Wyoming", text: "Wyoming" },

        ],

        MrMrs: [
            { value: "Male", text: "Male" },
            { value: "Female", text: "Female" },
            { value: "Other", text: "Other" }
        ],

        CaseTypes: [
            { value: "Multiple", text: "Multiple" },
            { value: "Individual", text: "Individual" },
        ],

        LevelOfPain: [
            { value: "1", text: "1" },
            { value: "2", text: "2" },
            { value: "3", text: "3" },
            { value: "4", text: "4" },
            { value: "5", text: "5" },
            { value: "6", text: "6" },
            { value: "7", text: "7" },
            { value: "8", text: "8" },
            { value: "9", text: "9" },
            { value: "10", text: "10" }
        ],

        BodyParts: [
            { value: "head", text: "Head" },
            { value: "neck", text: "Neck" },
            { value: "shoulders", text: "Shoulders" },
            { value: "back", text: "Back" },
            { value: "arms", text: "Arms" },
            { value: "elbows", text: "Elbows" },
            { value: "wrists", text: "Wrists" },
            { value: "hands", text: "Hands" },
            { value: "chest", text: "Chest" },
            { value: "abdomen", text: "Abdomen" },
            { value: "hips", text: "Hips" },
            { value: "legs", text: "Legs" },
            { value: "knees", text: "Knees" },
            { value: "ankles", text: "Ankles" },
            { value: "feet", text: "Feet" }
        ],

        multiPlaintiff: [
            { value: "Multiple", text: "Multiple" },
            { value: "Individual", text: "Individual" },
        ],

        apiAccessKeyNames: [
            { value: "ChartSquad", text: "ChartSquad" },
        ],

    }

    static MedicalProviderSections = [
        {
            providerType: MEDICAL_PROVIDER_TYPE.POST_ACCIDENT,
            heading: "Post-Incident Medical Records",
            reorderHeading: "Reorder Post-Accident Related Medical Providers"
        },
        {
            providerType: MEDICAL_PROVIDER_TYPE.PRE_ACCIDENT,
            heading: "Prior Medical Records",
            reorderHeading: "Reorder Pre-Accident Related Medical Providers"
        }
    ];

    static getAuthtoken = () => {
        let token = getLocalStorageItem("authtoken")
        if (!token || token === null || token === undefined) { return { isToken: false } }
        return { token: token, isToken: true }

    }

    static ToolTips = {
        liabilityFile: "Select which Defendants apply for each uploaded file"
    }

    static EmptyAddress = { zip: '', address: '', city: '', state: '' };

    static RolloverColor = [
        "#16857E",
        "#1CA79D",
        "#21C8BD",
        "#46D1C8",
        "#6BDAD3",
    ];

    static BarStatColorConstants = {
        ROLLOVER: ['#16857E', '#1CA79D', '#21C8BD', '#46D1C8', '#6BDAD3'],
        ALACARTE: ['#833F6E', '#A34E89', '#C45EA5', '#CE79B4', '#CE79B4'],
        FAILED_RECORDS: [
            '#FCF0CD',
            '#FBE7AB',
            '#F9D1B1',
            '#F6CE57',
            '#F4C22D',
            '#F2B603',
            '#CA9803',
            '#A17902',
            '#795B02',
            '#513D01',
            '#302401'
        ],
        MRR:['#16857E',' #1CA79D','#21C8BD','#46D1C8','#6BDAD3']
    };

    static BreadCrumbs = {
        discovery: {
            overview: { label: "DiscoveryOverview", value: "overview" },
            respondingQuestions: { label: "Responding Questions", value: "respondingQuestions" },
            respondingAnswer: { label: "Responding Answer", value: "respondingAnswer" },
            propoundingQuestions: { label: "Propounding Questions", value: "propoundingQuestions" },
            propoundingQuestionList: { label: "Propounding Questions", value: "propoundingQuestionList" },
            preference: { label: "Discovery Preferences", value: "preference" }
        }
    } 
    
}


export default Constants;
